import { render, staticRenderFns } from "./OracleImputationList.vue?vue&type=template&id=2044f09e"
import script from "./OracleImputationList.vue?vue&type=script&lang=js"
export * from "./OracleImputationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports